import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
const Header = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
  },
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
  },
}));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));
const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "15px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      marginBottom: "0px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
      marginBottom: "0px",
    },
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "5px",
    fontSize: "16px",
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  "&.showonMobile": {
    marginTop: "20px",
    [theme.breakpoints.up("lg")]: {
      "& p": {
        display: "none",
      },
    },
    [theme.breakpoints.down("md")]: {
      "& p": {
        display: "block",
        lineHeight: "22px",
      },
    },
  },
}));

export { Header, Linked, Maincontant };
